(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate-manual/assets/javascript/pages/home/components/instructions-info.js') >= 0) return;  svs.modules.push('/modules/tickets-validate-manual/assets/javascript/pages/home/components/instructions-info.js');
"use strict";

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const NeedHelp = svs.tur.NeedHelp;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
setGlobal('svs.ticketsValidateManual.pages.home.components.InstructionsInfo', () => React.createElement(GridRow, {
  className: "u-flex-justify-content-center padding-top-4"
}, React.createElement(GridCol, {
  am: 8,
  lg: 8,
  sm: 12
}, React.createElement(WidgetArea, {
  areaName: "stepByStepWidget",
  className: "pre-wrap"
}), React.createElement(NeedHelp, null))));

 })(window);